import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { setLanguage } from '../actions/language';
import { dispatch } from '../store';

i18n.use(initReactI18next).init({
  resources: {
    ko: {
      translation: {
        Setting: '설정',
        'Setting completed': '설정완료',
        'App reservation': '앱예약',
        'App reservation status': '앱 예약 가능 여부',
        'Maximum 6 characters can be entered': '최대 6글자만 입력가능합니다.',
        Possible: '가능',
        Impossible: '불가능',
        'Spot memo': '스팟 메모',
        'Spot basic settings': '스팟 기본 설정',
        'Preparation time': '여유 시간',
        Start: '시작',
        'Start immediately': '바로 시작',
        'Custom setting': '직접 설정',
        'Direct input': '직접입력',
        'Please enter': '입력해 주세요.',
        'Reservation cancellation time': '예약 취소 가능 시간',
        'Reservation available time': '예약 가능 시간',
        'Please set the time that members can reserve': '회원이 예약할 수 있는 시간을 설정합니다',
        'Before start time': '시작 시간 전',
        'No cancellation after reservation': '예약 후 취소 불가',
        'No same-day cancellation': '당일 취소 불가',
        'Absence processing standard': '결석 처리 기준',
        'Automatic absence processing': '자동 결석 처리',
        'Ticket deduction upon absence': '결석 시 수강권 차감 여부',
        'Deduct ticket': '수강권 차감',
        'Do not deduct ticket': '수강권 미차감',
        'Settings complete': '설정 완료',
        days: '일',
        hours: '시',
        before: '전까지',
        'Spot detail': '스팟 상세',
        'Member memo': '회원메모',
        'Move spot': '스팟이동',
        'Extend time': '시간연장',
        'Start time': '시작 시간',
        End: '종료',
        'End reservation': '예약 종료',
        'Are you sure you want to end this reservation?': '예약을 종료하시겠습니까?',
        Guest: '게스트',
        'Guest entry': '게스트 입장',
        'Member search': '회원검색',
        'Search by name and contact': '이름 및 연락처로 검색',
        'Usage ticket': '이용권',
        'Please select a usage ticket to reserve': '예약하실 이용권을 선택해 주세요',
        'Usage time': '이용시간',
        'Buffer time': '여유시간',
        'Reservation time': '예약시간',
        'Remaining usage ticket time': '이용권 잔여시간',
        'hours remaining': '시간 남음',
        'Usage ticket expiration date': '이용권 만료일',
        'Spot usage history': '스팟 이용 내역',
        'Check-in': '체크인',
        'Member name': '회원명',
        'Mobile phone': '휴대폰',
        'Usage ticket name': '이용권명',
        'Usage period': '이용기간',
        'Start date': '시작일',
        'Expiration date': '만료일',
        'Ticket type': '종류',
        'Ticket category': '구분',
        'Ticket count': '횟수',
        'Individual ticket': '개인',
        Unlimited: '무제한',
        'Assignment complete': '배정완료',
        'Waiting reservation': '대기예약',
        'is using': '사용중',
        'No member is currently using': '이용중인 회원이 없습니다.',
        minutes: '분',
        Buffer: '여유',
        'In use': '사용중',
        'Waiting for use': '사용대기',
        Unusable: '사용불가',
        Register: '등록',
        'Basic settings': '기본설정',
        Waiting: '대기자',
        team: '팀',
        people: '명',
        'View details': '상세보기',
        'Usage end time': '사용종료시간',
        'Expected usage time': '예상 이용시간',
        'minutes remaining': '분 남음',
        'Available for reservation': '예약가능',
        'Unavailable for reservation': '예약불가',
        'Keep me logged in': '아이디 저장',
        'Log in': '로그인',
        'Sign up': '회원가입',
        'Update Pass': '패스 업데이트',
        'Employee Management': '임직원 관리',
        'Center management': '센터 관리',
        'facility control': '시설 제어',
        'Revenue Management': '매출 관리',
        'Golf Management': '골프 관리',
        'Attendance management': '근태 관리',
        Admin: '통합관리자님',
        Manager: '관리자',
        'Center List': '센터 목록',
        'General member management': '일반 회원 관리',
        'Representative Information': '대표자 정보',
        'Corporate member management': '기업 회원 관리',
        'Select Branch': '지점 선택',
        'Area Select': '구역을 선택해 주세요.',
        'Please enter the area description': '구역 설명을 입력해 주세요.',
        'Please Select': '선택해 주세요.',
        'Spot zoning setting': '스팟 구역 설정',
        Zoning: '구역 설정',
        'Create Zone': '구역 생성',
        'Spot create': '스팟 구역 생성',
        'Area create': '구역 생성',
        'Area edit': '구역 수정',
        'Area setting': '구역 설정',
        'Update Area': '수정 완료',
        'Processing...': '처리 중...',
        'Spot detail setting': '스팟 상세 설정',
        'Spot area': '스팟 구역',
        'Spot number': '스팟 번호',
        'Spot name': '스팟 이름',
        'Area name': '구역 이름',
        'Spot status': '스팟 상태',
        'Area description': '구역 설명',
        'Horizontal line': '가로 줄',
        'Vertical line': '세로 줄',
        'Please enter the area name': '구역 이름을 입력해 주세요',
        'No created spot area': '생성된 스팟 구역이 없습니다.',
        'Create spot area': '스팟 구역을 생성해주세요',
        'Select the studio you want to check': '조회하실 지점을 선택해주세요',
        Search: '검색',
        'Search by your client’s name, ID, and phone number': '회원명, 아이디, 전화번호를 검색해주세요',
        'Search by member name or phone number': '회원명, 전화번호를 검색해 주세요',
        Go: '검색',
        'Add Client': '회원 등록',
        'Client Status': '회원 구분',
        'View All': '전체',
        ACTIVE: '사용',
        INACTIVE: '비사용',
        STOPPED: '중지 회원',
        EXPIRED: '만료 회원',
        WITHDREW: '탈퇴',
        'Clients with outstanding membership dues': '미수금 회원',
        'General product Detail': '일반상품 상세',
        'Class Type': '클래스 유형',
        event: '종목',
        'Sale Type': '판매 유형',
        'Type of product for sale': '판매상품 유형',
        '1-on-1': '개인 레슨',
        Group: '그룹 레슨',
        PRIVATE_LESSON: '개인 레슨',
        ONLINE_LESSON: '온라인 레슨',
        Duet: '듀엣 레슨',
        DUET_LESSON: '듀엣 레슨',
        OT: 'OT',
        GROUP_LESSON: '그룹 레슨',
        Online: '온라인 레슨',
        'View Pass': '수강권 상세',
        'Membership Detail': '회원권 상세',
        Gender: '성별',
        Male: '남성',
        Female: '여성',
        male: '남성',
        female: '여성',
        MALE: '남성',
        FEMALE: '여성',
        'Age Group': '연령대',
        'All Age Group': '전체',
        UNDER_30: '30 대 미만 ',
        AGE_30_40: '30대',
        AGE_40_50: '40대',
        AGE_50_60: '50대',
        OVER_60: '60대 이상',
        'SMS Updates': 'SMS수신',
        Yes: '동의',
        No: '미동의',
        'Credit Card': '카드 결제',
        Mobile: '휴대폰 결제',
        'Kakao Pay': '카카오 페이',
        'Naver Pay': '네이버 페이',
        'Additional Options': '추가옵션',
        'Remaining Lessons': '잔여 횟수',
        'Total Remaining Lessons': '총 잔여 횟수',
        UNDER_3: '3회 이하',
        UNDER_5: '5회 이하',
        UNDER_10: '10회 이하',
        'Expiry Date': '만료일',
        'Last Expiry Date': '최종 만료일',
        // 'DD/MM/YYYY': '날짜 선택',
        'dd/mm/yyyy': '년/월/일',
        'Within 5 days': '5일 이내',
        'Within 15 days': '15일 이내',
        'Within this month': '이번달 이내',
        'Within next month': '다음달 이내',
        '1 month': '1개월',
        '3 month': '3개월',
        '6 month': '6개월',
        '12 month': '12개월',
        'Locker Expiry Date': '라커 만료일',
        'Apply and Search': '설정한 조건으로 검색',
        'Clear Filters': '검색조건 초기화',
        SMS: 'SMS',
        'Download Excel File': '엑셀 다운로드',
        'Select all': '현재 해당되는 모든 {{instance}}({{count}}명) 선택',
        '3 results': '',
        'Display 10 results per page': '10개씩 보기',
        Name: '이름',
        Age: '나이',
        'Phone Number': '전화번호',
        'Activated Pass': '사용 수강권',
        Instructor: '담당자',
        Management: '관리 담당',
        'Total Payment Amount': '최근 결제금액',
        'Cumulative Total Visits': '누적 방문수',
        'First Payment Date': '첫 결제일',
        'Last Payment Date': '최근 결제일',
        'Attend Date': '이용일자',
        'Attend Start Time': '입장시간',
        'Attend End Time': '퇴장시간',
        'Attend Count': '입장횟수',
        'Ticket Info': '상품 정보',
        'Recent Visit': '최근 방문',
        'Select the studio you want to view': '조회하실 지점을 선택해주세요',
        'Select a classroom': '강의실을 선택해 주세요',
        'Please select a representative': '담당자를 선택해 주세요',
        'Please select a course': '수강권 선택을 해주세요',
        'Copy Weekly Schedule': '주간 일정 복사',
        Sun: '일',
        Mon: '월',
        Tue: '화',
        Wed: '수',
        Thu: '목',
        Fri: '금',
        Sat: '토',
        Delete: '삭제',
        'Client Details': '회원 정보',
        'Create Class': '수업 등록',
        'Number of deductions': '차감 횟수',
        'Update Class': '수업 수정',
        'Lesson Type': '레슨 구분',
        'Host Studio': '등록 지점',
        'Centreal Pilates Gangnam District Office Branch': '센트리얼 필라테스 강남구청점',
        'Class Title': '클래스 명',
        'Enter the class title': '클래스 명을 입력하여 주세요',
        Hall: '강의실',
        'Class Period': '등록 기간',
        'Select Date': '반복 요일',
        'Class Hour': '수업 시간',
        'Add Hours': '수업 시간 추가',
        'The end time will be automatically set to the hour after 50 minutes from the start time':
          '수업 종료 시간은 시작 시간 기준 50분 이후로 자동 설정 됩니다',
        'Schedule copied to next week': '주간 일정 복사가 완료되었습니다.',
        Client: '회원 선택',
        'Type the client’s name': '회원명을 입력하여 주세요',
        'Select Pass': '수강권 선택',
        'Select Hall': '강의실 선택',
        Remarks: '메모',
        'Type your notes': '일정 메모를 입력하여 주세요',
        'Registered by': '관리자',
        Cancel: '취소',
        Save: '저장',
        Confirm: '확인',
        'Center course ticket management': '매장 수강권',
        'Center course pass management': '매장 이용권',
        'VOD Pass': 'VOD 수강권',
        'Search Ticket': '수강권 검색',
        'Edit classroom': '강의실 수정',
        'Search Pass': '이용권 검색',
        'Type the pass title': '이용권 명을 검색해 주세요',
        'Type the ticket title': '수강권 명을 검색해 주세요',
        'Type the VOD title': 'VOD 명을 검색해 주세요',
        'Create Pass': '이용권 만들기',
        'List Pass': '수강권 만들기',
        'Create Package': '패키지수강권 만들기',
        'Session Package': '패키지 레슨',
        'Sales Status': '판매 상태',
        'Pending Approval': '승인 대기',
        'On Sale': '판매중',
        Completed: '판매종료',
        'Approval Rejected': '승인 반려',
        'In regular order': '정순',
        'Most recent': '최신순',
        'Display 20 results per page': '20개씩 보기',
        Studio: '지점명',
        'Please select a point': '지점을 선택 해주세요',
        'Pass Title': '수강권명',
        Period: '이용기간',
        'Number of Lessons': '이용횟수',
        'Duet Lesson Member Selection': '듀엣레슨 회원 선택',
        'View Calendar Time': '캘린더 시간 보기 설정',
        'Selling Price': '최종가',
        'Save Count': '찜하기 수',
        'General Information': '기본 정보',
        'Company information': '대표자 정보',
        'Seller Studio': '판매 지점',
        'Studio Name': '지점명',
        'Pass Type': '이용권권 분류',
        'ticked Type': '수강권 분류',
        'Duet Lesson Description': '듀엣 레슨은 강사 1명과 회원 2명이 함께 진행하는 수업입니다.',
        'VOD Type': 'VOD 분류',
        Sports: '운동 종목',
        'Please select at least one sport type': '운동 종목을 1개 이상 선택해주세요',
        'Kiosk Exclusive Products': '키오스크 전용 상품',
        'Choose a category': '카테고리 선택',
        'Type in the pass title': '수강권 명을 입력해주세요',
        'Sales Price': '판매 가격',
        'List Price': '정상가',
        'Discount Rate': '할인율',
        'Sales Period': '판매 기간',
        'No closing date': '종료일 없음',
        'Validity Period': '사용 기간',
        'Type in the period': '사용 기간을 입력해 주세요',
        'Type in the number of lessons': '사용 횟수를 입력해 주세요',
        'Day of use': '사용 횟수',
        'Number of uses': '사용 일수',
        'Please enter your class time': '수업 시간을 입력해 주세요',
        'Type in the number of usage': '이용 횟수를 입력해주세요',
        'Instructor(s)': '참여 강사',
        'Upload Instructor': '강사 업로드',
        Details: '상세 정보',
        'Pass Design': '수강권 이미지',
        'Uploading images: You may upload maximum 7 images in the PNG or JPEG formats. The suggested maximum size is 8MB, 1200 * 900 px (ratio 4:3). Small and medium size thumbnails will be automatically generated with your uploaded images':
          '이미지는 최대 7장, PNG/JPEG파일. 파일크기 최대 8MB, 가로세로 비율은 4:3, 1200*900px 사이즈를 권장합니다. 등록된 사진을 이용해서 중, 소 썸네일이 자동 생성됩니다',
        'Upload selected file': '이미지 업로드',
        'Create Curriculum': '커리큘럼 등록',
        'Pin to top': '상단 고정',
        'App push notification': '앱 푸쉬 알람',
        Title: '제목',
        Curriculum: '커리큘럼',
        Overview: '개요',
        Description: '내용을 입력하여 주세요',
        'Upload an image': '이미지 업로드',
        'Add Curriculum': '커리큘럼 추가',
        'Add Permission': '파트 권한 추가',
        'Up to 5 curriculums': '커리큘럼 최대 등록개수 5개',
        'We recommend dimensions of 1200 * 900 px (ratio 4:3). Small and medium size thumbnails will be automatically generated with your uploaded images. Images must be either in the JPG or PNG formats':
          '이미지 업로드 안내 이미지는 최대 8장, PNG/JPEG파일. 파일크기 최대 8MB, 가로세로 비율은 4:3, 1200*900px 사이즈를 권장합니다. 등록된 사진을 이용해서 중, 소 썸네일이 자동 생성됩니다',
        'Class Description': '클래스 상세',
        Post: '게시',
        '* By checking this box, you are sharing the description with users': '',
        Inquiry: '1:1 문의',
        Notice: '공지 사항',
        Event: '이벤트',
        Notification: '알림',
        'Attendance Management': '참석관리',
        'Add Waiting': '대기추가',
        'Add Reservation': '예약추가',
        'Attendance Status': '참석 현황',
        'Waiting Status': '대기 현황',
        'General Notification': '공통 메시지',
        'Client Application': '회원 앱',
        'Instructor Application': '강사 앱',
        'Administrator Application': '관리자 앱',
        'Reservation and Waiting Cancellation': '예약 및 대기 취소',
        'Duet Lesson Batch Deletion': '듀엣레슨은 일괄삭제만 가능합니다.',
        '': '',
        Date: '날짜',
        Today: '오늘',
        Week: '1주',
        Month: '월간',
        'Day(s)': '일',
        'Month(s)': '개월',
        'Lesson(s)': '회',
        'Minute(s)': '분',
        DAY: '일',
        MONTH: '개월',
        LESSON: '회',
        '3 Months': '3개월',
        All: '전체',
        'Inquiry Process': '처리현황',
        'Inquiry Type': '문의 구분',
        results: '개',
        'Page 1 of 6': '1/6페이지',
        'Inquiry Title': '문의 제목',
        Categories: '카테고리',
        Programs: '프로그램',
        Sessions: '세션',
        'If modified, the corresponding Your entire session will change':
          '수정할 경우 해당하는 하위 세션이 모두 변경 됩니다',
        'If deleted, the corresponding child All sessions will be deleted':
          '삭제할 경우 해당하는 하위 세션이 모두 삭제 됩니다',
        'Please enter the category name (within 10 characters)': '카테고리명을 입력해 주세요(10자 이내)',
        'Please enter the program name (within 10 characters)': '프로그램명 입력해 주세요(10자 이내)',
        Writer: '작성자',
        'Published Date': '작성일',
        'I have a question about purchasing a group lesson pass': '그룹레슨 수강권 구매 관련 문의 드립니다',
        'If I book a class, how late can I cancel it?': '예약을 했는데 취소는 언제까지 가능한가요?',
        'Who will be my private lesson instructor?': '개인레슨 강사 선생님 배정 문의',
        Write: '글쓰기',
        Number: '번호',
        'PilaTime lucky draw winner announcement': '필라타임 이벤트 당첨자 명단 공지',
        Writers: '작성자',
        Administrator: '관리자',
        Hits: '조회수',
        'Thu 10/27/2022': '2022.10.27(목)',
        EDIT: '수정',
        CONFIRM: '확인',
        person: '명',
        'Privacy Policy': '개인 정보 동의',
        'Terms & Conditions': '서비스 이용 약관',
        'Return & Exchange Policy': '교환/환불 안내',
        'Consent to the collecting and processing of personal data': '개인정보 수집 및 이용에 대한 동의',
        'Purpose of collecting and processing of personal data': '개인정보 수집 목적 및 이용목적',
        'To provide membership services of the shopping mall': '쇼핑몰 회원 서비스 제공',
        'Collecting Items': '수집하는 개인정보 항목',
        'Name, E-mail, contact information, address': '성명, 이메일, 전화번호, 주소',
        'Shopping History': '쇼핑내역',
        Home: '홈',
        'Client info': '회원 정보',
        'Ticket sales': '수강권 판매',
        'User Datails': '회원 상세',
        'Attendance/Reservation': '출결/예약 내역',
        'Consultation details': '상담 내역',
        Address: '주소',
        'Address*': '주소*',
        'Select Address': '주소 선택',
        DEFAULT: '예약',
        ATTENDED: '출석',
        ABSENT: '결석',
        RESERVED: '예약',
        'Send SMS': 'SMS 발송',
        'Address details': '상세 주소 입력',
        'Registration date​​': '등록일',
        'Detail Information': '추가 정보',
        'Retention and processing period of personal data': '개인정보의 보유기간 및 이용기간',
        'Terms marked with ( * ) must be entered. Using administrator privileges, you can change details like name, mobile number, email, etc. without checking for duplication':
          '( * ) 관리자 권한을 이용해서 이름,휴대폰 번호,이메일 등을 중복 확인 없이 변경할 수 있습니다',
        'In principle, if the purpose of using personal data had been attained, the personal data will be immediately destroyed. However, the information below will be retained for a specified period of time for specific reasons stated in the following':
          '원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다',
        'Employee Setting': '임직원 설정',
        'Salary Management': '급여 관리',
        'Payroll System': '급여 정산',
        'Search Employee': '임직원 설정',
        'Employee Settings': '임직원 검색',
        'Search by your employee’s name and phone number': '임직원 명, 연락처를 검색해 주세요',
        Create: '등록',
        'Create Area': '생성하기',
        line: '줄',
        Responsibilities: '담당 업무',
        'Employment Status': '재직 구분',
        'Employment Login': 'CRM 로그인',
        'Class in charge': '담당 수업',
        office: '재직중',
        leave: '퇴사',
        shower: '샤워',
        cafe: '카페',
        locker: '라커',
        'fitting room': '탈의실',
        'private room': '프라이빗룸',
        'parking lot': '주차장',
        balet: '발렛',
        sportswear: '운동복',
        towel: '타올',
        'aerobic equipment': '유산소기구',
        'group lesson': '그룹레슨',
        'private lessons': '개인레슨',
        'private schedules': '지점 스케줄',
        'women only': '여성 전용',
        Employed: '재직중',
        Resigned: '퇴사',
        'Employee Name': '임직원 명',
        'Contact Information': '연락처',
        'Hiring Date': '입사일',
        Designation: '설정',
        'Employee Information': '임직원 정보',
        NAME: '홍길동 님',
        Nickname: '닉네임',
        List: '목록으로',
        Clients: '담당회원 내역',
        'Employee Auth': '권한 관리',
        'Working time management': '근무시간관리',
        'Lessons & Appointments': '수업/예약 내역',
        'Web site': '홈페이지 주소',
        'Salary Details': '급여 설정 상세',
        'All fields marked with (*) are required. Administrators have access to change inputs including the name, phone number, and E-mail address without checking their availability':
          '( * ) 표시가 있는 항목은 반드시 입력해야 합니다. 관리자권한을 이용해서 이름,휴대폰 번호,이메일등을 중복확인없이 변경할 수 있습니다',
        'Name*': '이름(한글)*',
        'Name-': '이름(한글)',
        Agree: '동의',
        Disagree: '미동의',
        'Agree to receive SMS': '광고성 SMS 수신 동의',
        'Enter your name': '이름을 입력해주세요',
        'Without point': '미등록',
        'Studio Name*': '소속 지점*',
        'ID*': '아이디*',
        Email: '이메일',
        'Email*': '이메일*',
        ID: '아이디',
        MONDAY: '월요일',
        TUESDAY: '화요일',
        WEDNESDAY: '수요일',
        THURSDAY: '목요일',
        FRIDAY: '금요일',
        SATURDAY: '토요일',
        SUNDAY: '일요일',
        'Password not matched': '비밀번호가 일치하지 않습니다',
        'Room name': '강의실 이름',
        'Please enter room name': '강의실 이름 입력하세요',
        'List of rooms': '강의실 리스트',
        'Enter your ID': '아이디를 입력해 주세요',
        'Phone Number*': '휴대폰 번호*',
        'Phone Number-': '휴대폰 번호',
        'Enter your phone number': '휴대폰 번호를 입력해 주세요',
        'Password*': '비밀번호*',
        Password: '비밀번호',
        'Client Number​': '회원번호',
        'Passwords must contain at least two of the following: uppercase letters, lowercase letters, numbers, and symbols':
          '8~16자 영문,  숫자 및 특수문자 포함',
        'Confirm Password': '비밀번호 확인',
        'Confirm Password*': '비밀번호 확인*',
        'Login Type': '로그인 타입',
        'Must match the previous entry': '8~16자 영문,  숫자 및 특수문자 포함',
        'Date of Birth': '생년월일',
        Acception: '수신 동의',
        'Acception SMS': '광고성 수신동의',
        'E-mail*': '이메일*',
        'E-mail': '이메일',
        of: '중',
        'Enter your E-mail address': '이메일 주소를 입력해 주세요',
        'Instructor Profile': '메모',
        'Enter the instructor’s profile': '강사소개가 노출되는 영역입니다',
        'Personnel Information': '인사 정보',
        'Employee Create': '임직원 정보',
        'Resignation Date': '퇴사일',
        'Type the employee name': '임직원명을 검색해주세요',
        'Basic Pay': '기본급',
        '1-on-1 Pay': '개인 레슨 수당',
        'Group Pay': '그룹 레슨 수당',
        YES: '동의',
        NO: '비동의',
        'Online Pay': '온라인 수당',
        Commission: '커미션',
        'Effective from': '적용 시점',
        'Enter the department': '담당 부서가 표기되는 영역입니다',
        'Thu 11/15/2011': '2011.11.15(목)',
        '$1,200': '1,200,000원',
        'May, 2020': '2020년 5월',
        'Salary Breakdown': '급여 정보',
        'Pay Period Begin': '급여 반영일',
        '2021/05 -': '2021년 5월~현재',
        'Previous Salary Breakdown': '이전 급여정보',
        'Select Period': '반영 기간 선택',
        '2020/05 – 2021/04': '2020년 5월~2021년 4월',
        'Create Salary Details': '급여 설정 등록',
        'Pay Period': '적용 기간',
        'Start Date': '적용 시작',
        'Want Start Date': '판매일',
        'Sales Registration': '판매 등록',
        'Register For Refund': '환불 등록',
        'General Payment Details': '수강권 결제 관리',
        'Manually Registered Payment Details': '일반 상품 관리',
        'Member Search': '회원 검색',
        'Select Branch Manager': '담당자 선택',
        'Select Course Ticket': '수강권 선택',
        'Split payment': '나눠 결제',
        'Course Ticket Amount': '수강권 금액',
        'Select Product': '상품 선택',
        'Product Amount': '상품 금액',
        Memo: '메모',
        'Penalty Amount': '위약금',
        'Outstanding Amount': '미수금',
        'Use Amount': '이용 금액',
        'Refund Amount': '환불 금액',
        'Refund Of Amount': '최종 환불 금액',
        'Payment Amount': '결제 금액',
        'All Payment Amount': '총 결제 금액',
        'Payment Regular Amount': '판매 금액',
        'Refund Method': '환불 수단',
        Cancellation: '취소',
        'Please Enter a Note': '메모를 입력해 주세요',
        'Please Enter The Administrator Name': '관리자명을 입력하여 주세요',
        'Please Enter The Installment Month': '할부기간을 입력해주세요',
        'Please enter the last 4 digits of the card': '카드 뒷 4자리를 입력해주세요',
        'Please enter your approval number': '승인번호를 입력해주세요',
        'Enter Sales Information': '판매 정보 입력',
        'Please Enter Your Payment Method': '결제 수단을 입력하여 주세요',
        'Please Enter The Amount': '상품 선택 시 자동 생성',
        'Please Enter The Refund Amount': '환불 금액을 입력해주세요',
        'Please Enter The Use Amount': '이용 금액을 입력해주세요',
        'Please Enter The Penalty Amount': '위약금을 입력해주세요',
        'Please Enter The Outstanding Amount': '미수금을 입력해주세요',
        'Automatically generated when selecting a ticket': '수강권 선택시 자동 생성',
        'Automatically generated when selecting a product': '상품 선택시 자동 생성',
        'Automatically generated when selecting a pass': '이용권 선택시 자동 생성',
        'Please Enter The Refund Method': '환불 수단을 입력하여 주세요',
        'Enter Refund Information': '환불 정보 입력',
        '₩': '원',
        '[Image upload information] Size 800 * 600px, 4:3 ratio is recommended. Only jpg/png files can be registered':
          '[이미지 업로드 안내] 800 * 600px 사이즈, 4:3 비율을 권장합니다. jpg/png 파일만 등록 가능합니다',
        CANCEL: '취소',
        DELETE: '삭제',
        'The spots in this area will also be deleted': '스팟 구역을 삭제하시겠습니까?',
        'If you delete the spot area, it cannot be recovered.': '해당 스팟 구역을 삭제하시면 복구가 불가능합니다.',
        'Please be careful when deleting': '삭제된 데이터는 되돌릴 수 없으니 신중하게 진행해 주세요',
        'Are you sure you want to delete?': '삭제하시겠습니까?',
        'Do you want to edit it?': '수정하시겠습니까?',
        'Create/edit new category': '카테고리 신규 생성 / 수정',
        'Create/edit new programs': '프로그램 신규 생성 / 수정',
        'Create/Edit New Session': '세션 신규 생성 / 수정',
        'Timer settings (seconds)': '타이머 설정(초)',
        'Upload Image': '이미지 업로드',
        'Session Name': '세션명',
        'Session Description': '세션 설명',
        'Please enter a description': '설명을 입력해 주세요',
        'Please enter a session name (within 10 characters)': '세션명을 입력해 주세요(10자 이내)',
        'Category name': '카테고리 명',
        Year: '연도 선택',
        'End Date': '적용 종료',
        'No end date': '종료일 미지정',
        '3.3% statutory deduction applied': '공제율 3.3% 자동 반영',
        USD: '원',
        'Set a fixed allowance for one private lesson':
          '회원이 개인 레슨 1회 출석했을 때 지급하는 고정 수당 금액을 설정합니다',
        'Set a fixed allowance for one group lesson':
          '회원이 그룹 레슨 1회 출석했을 때 지급되는 고정 수당 금액을 설정합니다',
        'The employee earns a certain percentage of their gross salary as an additional compensation':
          '전체 급여의 해당 비율만큼의 추가 금액을 지급합니다',
        Payroll: '급여정산',
        'This Month': '금월',
        'December 2022': '2022년 12월',
        'Number of Employees': '임직원 수',
        'Total Gross Monthly Wage': '총 월 급여 합계',
        'Basic Sum': '기본급 합계',
        '1-on-1 Pay Sum': '개인 수당 합계',
        'Group Pay Sum': '그룹 수당 합계',
        'Online Pay Sum': '온라인 수당 합계',
        'Commission Sum': '커미션 합계',
        'Adjustment Sum': '조정 금액 합계',
        'Deduction Sum': '공제 금액 합계',
        'Net Pay Sum': '실 지급액 합계',
        'Gross Monthly Wage': '총 월 급여',
        Adjustment: '조정 금액',
        Deduction: '공제 금액',
        'Net Pay': '실 지급액',
        '2011.11.15(Thu)': '2011.11.15(목)',
        'Studio Overview': '매장 소개',
        'Studio Information': '매장 정보',
        'Studio Policies': '센터 설정',
        'Studio Policy': '이용 안내',
        'Add classroom': '강의실 추가',
        'Classroom Settings': '강의실 설정',
        'Private Lesson Settings': '개인레슨 설정',
        'Group Lesson Settings': '그룹레슨 설정',
        'Studio Settings': '지점 설정',
        Active: '사용',
        Inactive: '미사용',
        'Max class': '최대 수업',
        sessions: '세션',
        Edit: '수정',
        'Center Terms of Use': '센터 이용약관',
        'Electronic contract management': '전자계약서 관리',
        'Product Management': '상품 관리',
        'Business Name*': '사업자 명*',
        'Branch Name': '지점명',
        Category: '상품 분류',
        'Add Category': '상품 분류 추가',
        'Add Product': '신규 상품 등록',
        'Add Admin': '운영자 설정',

        'Branch List': '지점 목록',
        'Product List': '상품 목록',
        'Branch Number': '지점 번호',
        'Branch Contact': '지점 연락처',
        'Branch Manager': '지점 관리자',
        'Sale Manager': '판매 담당자',
        'Refund Manager': '환불 담당자',
        'Contact person': '담당자 연락처',
        'Contact Email': '담당자 이메일',
        'Branch type': '지점 유형',
        'Register a new branch': '신규 지점 등록',
        'Employer Identification Number*': '사업자 번호*',
        'Employer Identification Number': '사업자 번호',
        'Please enter your business number': '사업자 번호를 입력해 주세요',
        'Enter the business identification number': '사업자 번호를 입력해 주세요',
        'Please enter the industry/type of business': '업태/종목을 입력해 주세요',
        'Employer Type*': '사업자 구분*',
        'Employer Type': '사업자 구분',
        Individual: '개인',
        Entity: '법인',
        'Type of Business': '업태/종목',
        'Type of Business*': '업태/종목*',
        'Enter the type of business': '업태/종목을 입력하여 주세요',
        'Enter the phone number': '휴대폰 번호를 입력해 주세요',
        'Please enter your representative number': '대표번호를 입력해 주세요',
        'Enter the E-mail address': '이메일 주소를 입력해주세요',
        'Mailing Address*': '주소*',
        'Address/ZIP code search': '주소/우편번호 검색',
        'City, State or ZIP Code': '도로명, 지번, 건물명 검색',
        'Executor Name': '대표자 정보',
        'Enter executor name': '이름을 입력해 주세요',
        'Brief Introduction': '매장 소개 요약',
        'Business information': '사업자 정보',
        'Enter your studio introduction (Within 70 characters)': '매장 소개를 입력하여 주세요 (70자 이내)',
        Location: '위치 안내',
        'Enter your studio location (Within 70 characters)': '위치 안내를 입력하여 주세요 (70자 이내)',
        'Same with the address above': '주소와 동일',
        'Opening Hours': '영업 시간',
        Close: '휴무',
        Open: '영업',
        'Enter studio policies (Within 200 characters)': '이용 안내를 입력하여 주세요 (200자 이내)',
        Facility: '시설 안내',
        'About Studio': '매장 소개 상세',
        'Payment History': '결제 내역',
        Balance: '정산 내역',
        'Payment Method': '결제수단',
        'Payment Provider': '결제유형',
        'Payment Detail': '결제상세',
        'Card Company': '카드사',
        'Installment Month': '할부기간',
        'Card Number': '카드번호',
        'Approval Number': '승인번호',
        'Select Payment Method': '결제수단 선택',
        'Select Installment Month': '할부기간 선택',
        'Select Card Company': '카드사 선택',
        Payment: '결제',
        'Payment Status': '결제 상태',
        'Change payment': '결제 변경',
        'contract changes': '계약 변경',
        Paid: '결제',
        'Client Name': '회원명',
        Sum: '합계',
        Cancelled2: '퇴사일',
        'Date of Purchase': '결제 일시',
        'sale date': '판매일',
        'Discounted Price': '할인금액',
        Price: '가격',
        Inventory: '재고',
        'Product name': '상품명',
        Classification: '분류',
        '2022.11.15(Thu) 11am': '2022.11.15(목) 오전11:00',
        'Pilates Group 100 Lessons 12 Months': '필라테스 그룹 레슨 100회 12개월',
        'Credit card': '카드',
        'Body Switch Management': '바디 스위치 관리',
        'Session Management': '세션 관리',
        'Program category': '카테고리',
        Add: '추가',
        Program: '프로그램',
        Session: '세션',
        TICKET_APPROVED: '판매중',
        TICKET_APPROVAL_PENDING: '승인대기',
        TICKET_REFUSED: '승인반려',
        TICKET_EXPIRED: '판매종료',
        Cancelled: '취소',
        ORDER_CREATED: '대기',
        PAID: '결제',
        REFUNDED: '환불',
        CANCELED: '취소',
        'Main Menu': '대메뉴',
        'Sub Menu': '서브 메뉴',
        Permission: '권한 설정',
        OPERATORS: '운영자설정',
        'Operator management': '운영 관리',
        Dashboard: '대시보드',
        'Member management': '회원 관리',
        'Schedule management': '스케줄 관리',
        'Course ticket management': '수강권 관리',
        'Membership management': '회원권 관리',
        'Ticket management': '수강권 관리',
        'Pass management': '이용권 관리',
        'Center Trial ticket management': '일일권 관리',
        'Body switch management': '내 운동 기록',
        'Message management': '커뮤니티 관리',
        'SMS management': 'SMS 관리',
        'Employee management': '임직원 관리',
        'Sales management': '매출 관리',
        'Point of sale': '판매지점',
        'Pass name': '패스 이름',
        'Ticket name': '이용권 명',
        'Non-member exclusive products': '비회원 전용 상품',
        'General Admission': '일반 이용권',
        'All Products': '전체 판매 상품',
        NON_MEMBER: '비회원 전용 상품',
        KIOSK: '키오스크 전용 상품',
        GENERAL: '일반 이용권',
        'Create Trial': '일일권 생성',
        'Please enter the course name': '수강권 명을 입력해주세요',
        'Type the trial title': '일일권 명을 입력해 주세요',
        'Please enter the pass name': '이용권 명을 입력해 주세요',
        'Trial Title': '일일권 명',
        'Daily usage limit': '일일 이용 제한',
        'No daily usage limit': '일일 이용 제한 없음',
        'Times/Days': '회 / 일',
        'Weekly usage restrictions': '주간 이용 제한',
        'No weekly usage limit': '주간 이용 제한 없음',
        'Times/Week': '회 / 주',
        'Stop right': '중지권',
        'No restrictions on use': '이용 제한 없음',
        'Additional product settings': '추가 상품 설정',
        'Additional product name': '추가 상품명',
        'Selling price': '판매가격',
        'Add additional products': '추가 상품 추가',
        Use: '사용',
        'Search Trial': '일일권 검색',
        Unused: '미사용',
        'Modify your course ticket': '수강권 수정',
        'Modify your course pass': '이용권 수정',
        'Register your ticket': '이용권 등록',
        'Usage period type': '사용기간 유형',
        'Sales status': '판매 현황',
        'Terms of Use': '이용권 이용 약관',
        'Refund Policy': '수강권 이용 약관',
        'Already Used': '이미 등록된 아이디',
        '* If you check No limit, the value of that item will be set to unlimited.':
          '* 제한 없음을 체크하면 해당 항목의 값이 무제한으로 설정됩니다.',
        '* Set the maximum number of uses per week.': '* 일주일 최대 이용 횟수를 설정합니다.',
        '* Set the maximum number of uses per day.': '* 하루 최대 이용 횟수를  설정합니다.',
        '* Set the maximum number of times and number of days that use can be suspended within the use period.':
          '* 이용기간 내에 이용을 중지할 수 있는 최대 횟수와 일수를 설정합니다.',
        '* Choose the optimal settings for canceling your reservation.':
          '* 예약을 취소할 수 있는 최적의 설정을 선택하세요.',
        '* Set the maximum number of reservations that can be made simultaneously.':
          '* 동시에 총 예약할 수 있는 최대 횟수를 설정합니다.',
        'Video file': '센터 영상',
        'Video thumbnail': '센터 영상 썸네일',
        'Usage settings': '이용설정',
        'Upload class videos': '수업 영상 업로드',
        'Class pass video': '수강권 영상',
        'Center course VOD management': 'VOD 수강권',
        'Locker Management': '라커 관리',
        'Point Management': '포인트 관리',
        'Spot placement settings': '스팟 배치 설정',
        'Member app reservation settings': '회원앱 예약 설정',
        'Kiosk settings': '키오스크 설정',
        Update: '등록 / 수정',
        'Update ': '수정',
        'The classroom name updated': '강의실 이름이 수정되었습니다',
        'Member Name': '회원명',
        'Period of Use': '이용 기간',
        'Add 10 at a time': '10개씩 추가하기',
        'Do you want to delete the locker?': '라커를 삭제 하시겠습니까?',
        'Set the time for cancellation of reservation': '예약 취소 가능 시간 설정',
        'Time ago': '시간전',
        '* Set the period during which customers can cancel a confirmed class reservation. You can set the period based on the class start time':
          '* 확정한 수업 예약 건에 대해 고객이 취소할 수 있는 기간을 설정합니다. 수업 시작 시간을 기준으로 기간을 설정 할 수 있습니다',
        '* If you delete a classroom, you cannot control its schedule in the calendar':
          '* 주의 강의실을 삭제할 경우 일정 관리에서 해당 강의실의 스케줄을 제어할 수 없습니다',
        Banner: '배너',
        'Display status': '전시 상태',
        'Classification of course tickets': '수강권 구분',
        'Display location': '전시 위치',
        Post: '게시',
        Hidden: '미게시',
        Display: '전시',
        Position: '위치',
        'Shipment status': '발송 상태',
        State: '상태',
        'Landing Type': '랜딩 구분',
        'Landing Link': '랜딩 링크',
        'Image post': '이미지 삽입 글',
        'Landing ID': '랜딩 링크',
        'Select Course Pass': '이용권 선택',
        'Course Pass Amount': '이용권 금액',
        Pass: '이용권',
        Ticket: '수강권',
        Detail: '내용',
        'Send Notice': '공지 발송',
        'Sent completed': '발송 완료',
        'Inquiry Category': '문의 구분',
        'Transferable ticket': '양도할 수강권',
        'Transferable pass': '양도할 이용권',
        'Name of recipient': '양도 받으실분 이름',
        'Mobile phone number of recipient': '양도 받으실분 휴대폰 번호',
        Author: '작성자',
        Date: '작성일',
        Status: '처리현황',
        'Ticket Transfer': '수강권',
        Transfer: '양도/양수',
        'Transfer Menu': '양도 / 양수',
        'Pass Transfer': '이용권',
        'Transfer Approved': '양도 승인됨',
        'Transfer Approve': '양도 승인',
        'Transfer Canceled': '양도 취소됨',
        'Transfer Cancel': '양도 취소',
        'Transfer canceled': '양도가 취소되었습니다',
        'Are you sure you want to cancel this transfer?':
          '해당 양도를 취소(롤백)하시겠습니까? 당일 양도만 취소할 수 있으며, 양수자가 예약·출석·중지한 경우 취소할 수 없습니다.',
        'Weekly View': '주간 보기',
        'Daily View': '일일 보기',
        'Please select an instructor': '강사를 선택해 주세요',
        'Private lesson': '개인 레슨',
        'Group lesson': '그룹 레슨',
        'Group Schedule': '그룹 스케줄',
        // 'Online lesson': '온라인 레슨',
        'Golf batting management': '골프 타석 관리',
        Fitness: '피트니스 / P.T',
        Pilates: '필라테스',
        Golf: '골프',
        Crossfit: '크로스핏',
        Yoga: '요가',
        'Ball games': '구기 / 라켓',
        Boxing: '복싱 / 격투',
        Dance: '댄스',
        FITNESS: '피트니스 / P.T',
        PILATES: '필라테스',
        GOLF: '골프',
        CROSSFIT: '크로스핏',
        YOGA: '요가',
        BALL_GAMES: '구기 / 라켓',
        BOXING: '복싱 / 격투',
        DANCE: '댄스',
        BARRE_PILATES: '바레 필라테스',
        SWIMMING: '수영 / 수상',
        CYCLE: '사이클',
        EDUCATION: '교육',
        TANNING: '태닝',
        STRETCHING: '스트레칭',
        SENT: '전송',
        CREATED: '생성됨',
        Swimming: '수영 / 수상',
        Cycle: '사이클',
        Tanning: '태닝',
        Stretching: '스트레칭',
        'Please select a classroom': '강의실을 선택해주세요',
        'Start of healthy habits and management': '건강한 습관, 관리의 시작 바디스위치',
        'Enter the product name you wish to add': '추가하실 상품명을 기재해 주세요',
        'Enter the selling price': '판매 가격을 기재해 주세요',
        Uploading: '업로드중입니다',
        'Course Ticket Name': '수강권 명',
        'Amount of payment': '최종 결제 금액',
        payment: '결제 금액',
        'Payment Fee': '환불 금액',
        'Center selection': '센터 선택',
        'Work Classification': '재직 구분',
        'Please select the center to search': '조회하실 센터를 선택해주세요',
        'Create Ticket': '수강권 생성',
        'Create VOD': '수강권 만들기',
        Chat: '채팅 문의',
        'Reverse order': '역순',
        'Sort by price': '가격순',
        'Sort by number of uses': '이용횟수순',
        'File is too large. Maximum size is 5MB': '파일이 너무 큽니다. 최대 크기는 5MB입니다',
        WORKING: '재직중',
        LEFT: '퇴사',
        STORE_MANAGEMENT: '매장 관리',
        CUSTOMER_MANAGEMENT: '고객 관리',
        SELECT: '선택',
        READ: '열람',
        'Please enter your ID (email)': '아이디(이메일)를 입력해주세요',
        WRITE: '편집',
        'Use or not': '사용 여부',
        'Set Part Permissions': '파트 권한 설정',
        'Search by name or ID': '이름, 아이디를 검색해 주세요',
        'Operator registration': '운영자 등록',
        'Created date': '생성일​',
        'Last access date': '최근 접속일',
        'Delete selection': '선택 삭제',
        'Please enter the contents': '내용을 입력해주세요',
        'Register as a corporate member': '기업 회원 등록',
        'Home page URL': 'URL을 입력해 주세요',
        Effective: '유효',
        Period: '기간',
        APPROVED: '승인',
        APPROVAL_PENDING: '대기',
        REFUSED: '불가',
        'Search for members with set conditions': '설정한 조건으로 회원 검색',
        'Search for store with set conditions': '설정한 조건으로 매장 검색',
        'Reset search conditions': '검색조건 초기화',
        'Send message': '메시지 전송',
        'Send message': '가입일',
        'Excluding members who do not agree to receive SMS': 'SMS 수신 비동의 회원 제외',
        'All currently applicable persons': '현재 해당되는 모든 인원',
        'Business name': '사업자 명',
        'Business Information': '사업자 정보',
        'Phone number': '휴대폰',
        'Phone number*': '휴대폰*',
        'Date of joining': '가입일',
        'Successfully updated': '저장되었습니다',
        'Successfully delete': '삭제되었습니다',
        'Corporate Member Details': '기업 회원 상세',
        'Corporate Member great': '기업 회원 등록',
        Back: '뒤로가기',
        Authentication: '인증',
        'Authentication Verification': '인증확인',
        'Please enter your name': '이름을 입력해 주세요',
        'Please enter your business name': '사업자 명을 입력해 주세요',
        'Representative number (optional)': '대표번호(선택)',
        'Representative number (required)': '대표번호(필수)',
        'Representative number*': '대표번호*',
        'Email (optional)': '이메일(선택)',
        'Homepage (optional)': '홈페이지(선택)',
        'Account Status': '계정 상태',
        Homepage: '홈페이지',
        'Plan Type': '플랜 타입',
        'level status': '등급 상태',
        'Plan type updated successfully': '플랜 타입이 변경되었습니다',
        'Center ID not found': '센터 ID를 찾을 수 없습니다',
        'Search by your employees name and phone number': '직원 이름과 전화번호로 검색하세요.',
        LITE: '라이트',
        PRO: '프로',
        'Representative name': '대표자 명',
        'Representative number': '대표번호',
        "Representative's mobile phone": '대표자 휴대폰',
        'Representative Email': '대표자 이메일',
        'Sales Authority': '판매 권한',
        HEAD: '센터',
        BRANCH: '지점',
        'Select date': '날짜 선택',
        'Representative sports': '대표 운동 종목',
        'You can select up to 3.*': '*최대 3개 까지 선택 가능합니다',
        'You can use this username': '사용 가능한 아이디입니다',
        'Representative Product Information': '대표 상품 정보',
        'Successfully saved': '저장되었습니다',
        'Classroom added': '강의실이 추가되었습니다',
        'A cancellation time has been set': '센터 설정이 저장 되었습니다',
        'The classroom has been deleted': '강의실이 삭제되었습니다',
        'Category updated successfully': '상품 분류 갱신되었습니다',
        'Category deleted successfully': '상품 분류 삭제되었습니다',
        'Category created successfully': '상품 분류 추가되었습니다',
        'Please enter the price information for the most frequently used membership/class tickets, as displayed in the center introduction.*':
          '*센터 소개에 표시되는 가격으로, 회원께서 가장 많이 사용하시는 이용/수강권에 대한 가격정보를 입력하여주세요',
        'Please enter your password (8 to 16 characters including English letters, numbers, and special characters)':
          '8~16자 영문, 숫자 및 특수문자 포함',
        'Are you sure want to delete?': '정말 삭제하시겠습니까?',
        'Product has been registered': '상품 등록되었습니다',
        'Product has been modified': '상품 수정되었습니다',
        'Product has been deleted': '상품 삭제되었습니다',
        'The locker has been deleted': '라커가 삭제되었습니다',
        'The locker has been updated': '라커 정보가 수정되었습니다',
        'Form has been reset': '라커 정보가 초기화되었습니다',
        'Logged in': '로그인되었습니다',
        'Logged out': '로그아웃 되었습니다',
        'Center status changed': '판매 권한이 변경되었습니다',
        'Employees have been registered': '임직원이 등록되었습니다',
        'Employee information has been modified': '임직원 정보가 수정되었습니다',
        'Salary information has been registered': '급여 정보 등록되었습니다',
        'Salary information has been updated': '급여 정보 수정되었습니다',
        'Pay Period End': '급여 기간 종료일',
        'Please enter your ID': '아이디를 입력해 주세요',
        'Please enter your verification number': '인증확인 번호를 입력해주세요',
        'Please enter your email': '이메일을 입력해 주세요',
        'Please enter your address': '주소/우편번호 검색',
        'Please enter your detailed address': '상세 주소를 입력해 주세요',
        'Member information has been modified': '회원 정보가 수정되었습니다',
        '(*) Items marked with a must be filled in. You can change your name, mobile phone number, email, etc. without duplication check using administrator rights':
          '( * ) 표시가 있는 항목은 반드시 입력해야 합니다. 관리자 권한을 이용해서 이름,휴대폰 번호,이메일등을 중복 확인 없이 변경할 수 있습니다',
        'success deleted category': '카테고리가 삭제되었습니다',
        'success deleted program': '프로그램 삭제되었습니다',
        'success deleted session': '세션 삭제되었습니다',
        'Program created successfully': '프로그램 추가되었습니다',
        'Program updated successfully': '프로그램 수정되었습니다',
        'Create program session success': '세션 추가되었습니다',
        'Update program session success': '세션 수정되었습니다',
        'Category created successfully ': '카테고리가 추가되었습니다',
        'Created successfully': '추가되었습니다',
        'Successfully created': '매장 등록되었습니다',
        MAIN_01: '메인_01',
        MAIN_02: '메인_02',
        MAIN_03: '메인_03',
        POSTING: '게시중',
        HIDDEN: '미게시',
        TICKET: '수강권',
        PASS: '이용권',
        ADS: '광고',
        'Banner created successfully': '배너가 생성되었습니다',
        'Banner updated successfully': '배너가 수정되었습니다',
        'Banner(s) Deleted': '배너가 삭제되었습니다',
        'Image exceeds the maximum allowed dimensions of 686x310': '이미지 크기는 최대 686x310까지 업로드 가능합니다',
        'Only PNG and JPG files are allowed': '이미지는 png, jpg 만 업로드 가능합니다',
        'Notice created successfully': '공지사항이 등록되었습니다',
        'Notice updated successfully': '공지사항이 수정되었습니다',
        'Notice(s) Deleted': '공지사항이 삭제되었습니다',
        'Notice(s) SENT': '공지사항이 발송되었습니다',
        'Ticket transfer approved': '수강권 양도 승인되었습니다',
        'Pass transfer approved': '이용권 양도 승인되었습니다',
        'Class updated successfully': '레슨이 수정되었습니다',
        'Class created successfully': '레슨이 생성되었습니다',
        'Pass created successfully': '이용권이 생성되었습니다',
        'Pass Deleted': '이용권 삭제되었습니다',
        'Pass status Changed': '이용권 판매 상태 변경되었습니다',
        'Ticket created successfully': '수강권이 생성되었습니다',
        'Ticket status Changed': '수강권 판매 상태 변경되었습니다',
        'Ticket Deleted': '수강권 삭제되었습니다',
        'VOD created successfully': 'VOD 수강권 등록되었습니다',
        'VOD updated successfully': 'VOD 수강권 수정되었습니다',
        'VOD Deleted': 'VOD 삭제되었습니다',
        'Please enter the number of uses': '이용 횟수를 입력해 주세요',
        'Golf settings updated successfully': '골프 설정이 수정되었습니다.',
        CARD: '카드',
        'Program name': '프로그램 명',
        Ok: '확인',
        'Deletion completed': '삭제 완료 됐습니다',
        'Save completed': '저장 완료 됐습니다',
        'Update completed': '업데이트  완료 됐습니다',
        'Select Second': '시간 설정',
        'Please enter the product name': '상품 명을 입력해 주세요',
        'Please enter your selling price': '판매 가격을 입력해 주세요',
        'Select Room': '강의실을',
        'Please search for business name, nickname, and mobile phone number':
          '사업자 명, 닉네임, 휴대폰을 검색해 주세요',
        'General Member Management': '일반 회원 관리',
        'Corporate Membership Management': '기업 회원 관리',
        'Class Counts': '수업 정원',
        'Waiting Counts': '대기 정원',
        'Managing unregistered members': '미등록 회원 관리',
        'Managing temporary members': '잠재 회원 관리',
        'App link requests': '앱 연동 요청',
        'Managing Attend Hisyory': '입장 내역 관리',
        'Extension time': '연장시간',
        'Changed end time': '변경된 종료 시간',
        'Extension complete': '연장완료',
        'Waiting list status': '대기자 현황',
        'No waiting members': '대기자가 없습니다.',
        'No usage history': '이용 내역이 없습니다.',
        'Call employee': '직원 호출',
        'Call employee description': '* 키오스크에서 직원호출 시 알림톡을 전송할 직원을 설정합니다.',
        'Maximum number of employees': '최대 5명',
        'Search employee': '임직원명 또는 전화번호 검색',
        'No search results`': '검색결과가 없습니다,',
        'Spot layout image': '타석 배치도 이미지',
        'Spot layout image description': '* 키오스크에서 타석 배치도를 눌렀을 때 노출될 이미지를 설정합니다.',
        'Spot layout image size': '640*640 / 2MB 이하',
        'Please select the spot area': '스팟구역을 선택해 주세요',
        'Upload image': '이미지 업로드',
        'Save settings': '설정저장',
        출근: '출근',
        퇴근: '퇴근',
        지각: '지각',
        결근: '결근',
        조퇴: '조퇴',
        '출근 시간': '출근 시간',
        '퇴근 시간': '퇴근 시간',
        '근무 시간': '근무 시간',
        'Total records': '전체 기록',
        'No attendance records found': '출퇴근 기록이 없습니다',
      },
    },
    en: {
      translation: {
        Cancelled2: 'Cancelled',
      },
    },
  },
  lng: localStorage.getItem('lang') || 'ko',
  interpolation: {
    escapeValue: false,
  },
});

export function setCurrentLang(lang = 'ko') {
  i18n.changeLanguage(lang);
  dispatch(setLanguage(lang));
}

export function changeLang() {
  const lang = localStorage.getItem('lang');
  if (lang === 'en') {
    localStorage.setItem('lang', 'ko');
    setCurrentLang('ko');
  } else {
    localStorage.setItem('lang', 'en');
    setCurrentLang('en');
  }
}

export default i18n;
